module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "//fonts.googleapis.com/icon?family=Material+Icons"
    }
  }), _vm._v(" "), _c('md-icon', [_vm._v("home")]), _vm._v(" " + _vm._s(_vm.$i18n.locale) + " " + _vm._s(_vm.$t('hello')) + "\n    "), _c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("JCID Inquiry Request Test")])]), _vm._v(" "), _c('md-card-content', [_c('md-input-container', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('label', [_vm._v("Request URL")]), _vm._v(" "), _c('md-input')], 1), _vm._v(" "), _c('md-input-container', {
    staticStyle: {
      "width": "140px"
    }
  }, [_c('label', [_vm._v("UserID")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.userID),
      callback: function($$v) {
        _vm.userID = $$v
      },
      expression: "userID"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v("XML_Content")]), _c('br'), _vm._v(" "), _c('textarea', {
    staticStyle: {
      "width": "90%",
      "height": "20em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.submitInquiry($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "result"
  }, [_c('md-dialog-title', [_vm._v("Result")]), _vm._v(" "), _c('md-dialog-content', [_c('textarea', {
    staticStyle: {
      "width": "590px",
      "height": "20em"
    }
  }, [_vm._v(_vm._s(_vm.result))])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('result')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Mdf',
        params: {
          id: '100entry--R110h-1_25-2321Y'
        }
      }
    }
  }, [_vm._v("mdf")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fee4250e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Material.vue
// module id = 457
// module chunks = 1